/**
 * LOS PREDIOS BAJO NUESTRO CUIDADO (Definición 74).
 *
 * 🟥 ESTÁ VACÍO A PROPÓSITO, Y ESO ES EL DATO. Regla dura de Faina (28-ago):
 * todo lo que publicamos debe ser verdad, y el modo real de fallar no es
 * mentir: es poner una cifra de META donde se acreditan HECHOS. Ese día la web
 * decía «278 canalizaciones propias» —escritas 94— y «33 idiomas» —traducidos
 * 0—. Una página de Conservación es exactamente el mismo terreno resbaladizo:
 * las 30 hectáreas de nuestro fundador son reales, pero su donación NO ESTÁ
 * FORMALIZADA, y hasta que lo esté no hay ni una hectárea bajo nuestro cuidado.
 *
 * Por eso el bloque «lo que ya cuidamos» de la página LEE ESTA LISTA en vez de
 * llevar un texto escrito a mano: mientras esté vacía, la página dice que no
 * hay ninguno; en cuanto entre el primero, se muestra solo. No hay forma de que
 * el texto y la realidad se separen, que es como se cuelan las cifras falsas.
 *
 * CÓMO SE AÑADE UNO. Solo cuando el acuerdo está firmado e inscrito — no
 * cuando se conversa, ni cuando se promete, ni cuando se firma un borrador:
 *
 *   {
 *     nombre: 'Nombre del predio',
 *     lugar: 'Comuna, Región',      // sin coordenadas: se protege, no se expone
 *     hectareas: 30,
 *     via: 'derecho real de conservación' | 'custodia' | 'propiedad',
 *     desde: '2026-09-01',          // fecha de la inscripción, no del acuerdo
 *     ultimaVisita: '2026-09-01'    // la del último informe publicado
 *   }
 *
 * Fuente de verdad de papel: 4 OPERACIÓN Y SISTEMAS/REGISTROS Y TABLAS/
 * TABLA DE PREDIOS EN CONSERVACION.xlsx. Esta lista se llena desde ella, igual
 * que Agradecimientos se llena desde la Tabla de Música.
 *
 * Lo vigila `pruebas/pruebas.js`, bloque «Conservación».
 */
export const PREDIOS = [];

/** Hectáreas realmente bajo cuidado hoy. Se cuentan, no se declaran. */
export const HECTAREAS = PREDIOS.reduce((t, p) => t + (p.hectareas || 0), 0);
